module.exports = __webpack_public_path__ + "static/media/web-profile-pic.a8c3cd5c.jpg";